const config = {
  sentry: 'https://cfb89b4197334bfebcedeb8c44ffbf06:978d276675c448d2b9f2e1257584cbaf@o410294.ingest.sentry.io/5284085',
}

export default config
